import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FeedbackContext } from '@cvt/contexts';
import { useDictionary } from '@cvt/hooks/useDictionary';

import { cacheKeys as authCacheKeys } from '@modules/Auth/config';
import { cacheKeys } from '../config';
import { tributeClient } from '../client/tributeClient';


export const useTributeCrud = () => {
  const { genericErrorFeedback, triggerFeedback } = React.useContext(FeedbackContext);
  const queryClient = useQueryClient();
  const dictionary = useDictionary();

  const createTribute = useMutation({
    mutationKey: [cacheKeys.createTribute],
    mutationFn: tributeClient.createTribute,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getTributes],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const createParcel = useMutation({
    mutationKey: [cacheKeys.createParcel],
    mutationFn: tributeClient.createParcel,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getTributes],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getTribute, String(data.data.id)],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const editTribute = useMutation({
    mutationKey: [cacheKeys.editTribute],
    mutationFn: tributeClient.editTribute,
    onSuccess: (data) => {
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });

      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getTribute, String(data.data.id)],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getTributes],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const payWithCredit = useMutation({
    mutationKey: [cacheKeys.payWithCredit],
    mutationFn: tributeClient.payWithCredit,
    onSuccess: (result, tributeId) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getTribute, String(tributeId)],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getTributes],
      });
      queryClient.invalidateQueries({
        queryKey: [authCacheKeys.getMe],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    createTribute,
    editTribute,
    payWithCredit,
    createParcel,
  };
};